module.exports = __webpack_public_path__ + "img/hiring.afc3e237.jpg";